import {useGiftCardQualifiedPromotions} from '@/hooks';
import React, {useState} from 'react';
import {PromotionModal} from './PromotionModal';

export const Promotions = () => {
	const {data: offers, isLoading, error} = useGiftCardQualifiedPromotions();
	const [currentIndex, setCurrentIndex] = useState(0);

	if (error) {
		console.log('Promotions failed to load: ', error);
		return null;
	}

	// Prevent out-of-bounds access
	const isValidIndex = offers && currentIndex >= 0 && currentIndex < offers.length;
	const currentModal = isValidIndex ? offers[currentIndex] : null;

	const handleClose = () => {
		// Move to the next modal if any
		setCurrentIndex((prev) => prev + 1);
	};

	return (
		currentModal && (
			<PromotionModal
				{...currentModal}
				open
				isLoading={isLoading}
				onClose={handleClose}
				analytics={{
					eventCategory: 'popup',
					interactionType: 'click',
					eventAction: 'closePromotion',
					eventLabel: 'Fortnite Bonus Item',
					eventValue: {
						component: 'SpendStep',
						section: 'products',
						subView: 'Accept Promotions',
						interactedElement: 'Promotion Claim'
					}
				}}
			/>
		)
	);
};
